import { render, staticRenderFns } from "./SettingsLibraries.vue?vue&type=template&id=0974148c&scoped=true"
import script from "./SettingsLibraries.vue?vue&type=script&lang=js"
export * from "./SettingsLibraries.vue?vue&type=script&lang=js"
import style0 from "./SettingsLibraries.vue?vue&type=style&index=0&id=0974148c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0974148c",
  null
  
)

export default component.exports